<template>
  <div>
    <div class="form-control-label" v-if="label">{{ label }}</div>

    <div v-for="(option, index) in options" :key="option.text">
      <div class="custom-control custom-radio">
        <input
          :id="id + index"
          :name="id"
          type="radio"
          :value="option.value"
          :checked="option.value === value"
          :class="inputClass"
          class="custom-control-input"
          :disabled="disabled"
          :required="required"
          @change="updateValue(option.value)"
        />
        <label :for="id + index" class="custom-control-label">{{
          option.text
        }}</label>

        <slot v-if="option.value === value" :name="option.value" />
      </div>
    </div>
    <validation-provider v-slot="{ errors }" :name="label" rules="required">
      <input type="hidden" v-model="selected" />
      <slot name="error">
        <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
          {{ errors[0] }}
        </div>
      </slot>
    </validation-provider>
  </div>
</template>

<script>
export default {
  name: "m-radio",
  model: {
    event: "change",
    selected: null,
  },
  props: {
    rules: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    options: {
      type: [Array],
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Object],
      default: "",
    },
  },
  methods: {
    updateValue(value) {
      this.selected = value;
      this.$emit("change", value);
    },
  },
};
</script>
